import React from "react";
import { useTranslation } from "react-i18next";
import { Redirect, Route, RouteComponentProps, Switch } from "react-router-dom";
import Header from "go-app/components/Header";
import SubmenuToolsNavigation from "./components/SubmenuToolsNavigation";
import AdminToolsIndexPage from "./pages/Index";
import AdminToolsProductCatalogPage from "./pages/ProductCatalog";

const AdminToolsPage = (props: RouteComponentProps) => {
	const { t } = useTranslation("admin");

	return (
		<div className={"content"}>
			<Header title={t("modules.tool.header.title")} />
			<SubmenuToolsNavigation />
			<Switch>
				<Route path={`${props.match.url}/Index`} component={AdminToolsIndexPage} />
				<Route path={`${props.match.url}/product_catalog`} component={AdminToolsProductCatalogPage} />
				<Redirect from={props.match.url} exact to={`${props.match.url}/Index`} />
			</Switch>
		</div>
	);
};

export default AdminToolsPage;
